<script setup>
</script>

<template>
  <div>
    <h1 v-t="'error.h.error403'" />
    <p v-t="'error.m.error403'" />
    <router-link
      to="/login"
      v-t="'common.l.backToLogin'"
    />
  </div>
</template>
